import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { CarService } from 'src/app/services/car/car.service';
import { AddVisitNewCarModalComponent } from '../add-visit-new-car-modal/add-visit-new-car-modal.component';
import { UserService } from 'src/app/services/user/user.service';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { VisitService } from 'src/app/services/visit/visit.service';

@Component({
  selector: 'app-add-visit-new-user-modal',
  templateUrl: './add-visit-new-user-modal.component.html',
  styleUrls: ['./add-visit-new-user-modal.component.css']
})
export class AddVisitNewUserModalComponent implements OnInit {
  carSelect: any;
  userSelect: any;
  cars = [];
  visitForm: FormGroup;
  users = [];

  constructor(
    public dialogRef: MatDialogRef<AddVisitNewCarModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private alertService: AlertService,
    private visitService: VisitService,
    private userService: UserService,
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.userService.getUserVisits(this.data.idEntity).subscribe((response) => {
      this.users = response.data;
    },
      (error: HttpErrorResponse) => {

      });
  }

  get f() {
    return this.visitForm.controls;
  }

  createForm(){
    this.visitForm = this.formBuilder.group({
      idCar: [0, [Validators.required]],
      idUser: [0, [Validators.required]]
    });
  }

  changeCar(data) {
    var charselect = this.data.cars.filter(x => x.id == data.value)[0];
    this.carSelect = charselect;
  }

  changeUser(data) {
    var userselect = this.users.filter(x => x.userId == data.value)[0];
    this.userSelect = userselect;
  }

  save(){

    if(this.carSelect == undefined ||  this.userSelect == undefined){
      this.alertService.showMessage(
        "Debe seleccionar el vehículo y usuario",
        "",
        MessageSeverity.error);
      return false;
    }

    if(this.data.idVisit > 0){
      this.userSelect.idCar = this.carSelect.id;
      this.userSelect.licensePlate = this.carSelect.licensePlate;
      //this.userSelect.id = parseInt((new Date().getTime() / 1000).toFixed(0));
      var payload = {
        idVisit: +this.data.idVisit,
        idUser: this.userSelect.userId,
        idCar: this.carSelect.idCar,
      };
      this.visitService.createVisitUser(payload).subscribe((response) => {
        if(response){
          this.userSelect.id = response;
          this.dialogRef.close({user: this.userSelect});
        }else{

        }
      });
    }else{
      this.userSelect.idCar = this.carSelect.id;
      this.userSelect.licensePlate = this.carSelect.licensePlate;
      this.dialogRef.close({user: this.userSelect});
    }

  }
}
